import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Game } from "speakid-critter-quiz";
import "speakid-critter-quiz/style.css";

import Config from "../../Config";
import PersonalDefaultPage from "../personal/PersonalDefaultPage";

export default function CritterQuiz() {
  const navigate = useNavigate();

  const baseURL =
    typeof window !== "undefined" ? "/cloud/speakid/games/critter-quiz/" : "";

  useEffect(() => {
    axios
      .get(Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod")
      .then((res) => {
        if (res.status === 200 && res.data.status === "not_paid") {
          navigate("/billing/");
        }
      })
      .catch(() => {});
  }, [navigate]);

  return (
    <PersonalDefaultPage>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Game baseURL={baseURL} showLogo />
      </div>
    </PersonalDefaultPage>
  );
}
